export default __webpack_public_path__ + "static/media/markit-pay-mobile.7c27fa15.png";